const STORAGE_KEY = 'whatsNewHidden';

export const setWhatsNewHidden = (hidden) => {
  if (hidden) {
    localStorage.setItem(STORAGE_KEY, 'true');
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
};

export const getDefaultAppPath = (userRole) => (
  userRole === 'rider' ? '/riders-portal' : '/'
);
